<template>

    <v-modal title="Embed Form" :loading="starting" :padding="false">

        <template #nav>
            <a :class="{ active: tab === 'embed' }" href="#" @click.prevent="tab = 'embed'">Standard Installation</a>
            <a :class="{ active: tab === 'html' }" href="#" @click.prevent="tab = 'html'">Custom Installation</a>
        </template>

        <template #body>
            <template v-if="tab === 'embed'">
                <v-form-group dir="ver" label="1. Add the form container to your page:">
                    <v-code-box :code="embedCode1.trim()" language="html" />
                </v-form-group>
                <v-form-group dir="ver" label="2. Initialize the CrowdPower JavaScript Tag:">
                    <v-code-box :code="embedCode2.trim()" language="html" />
                </v-form-group>
                <v-form-group dir="ver" label="3. Display the form:">
                    <v-code-box :code="embedCode3.trim()" language="html" />
                </v-form-group>
            </template>
            <template v-else-if="tab === 'html'">
                <v-form-group dir="ver" label="Customize the form yourself using just the HTML:">
                    <v-code-box :code="form.embed.html" />
                </v-form-group>
            </template>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <div></div>
        </template>

    </v-modal>

</template>

<script>

import axios from 'axios';
import FormApi from '@api/FormApi';
import ProjectApi from '@api/ProjectApi';

export default {

    data() {
        return {
            starting: true,
            tab: 'embed',
            apiKeys: [],
        }
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

        token() {
            let key = this.apiKeys.find(k => k.type === 'pk');
            return key.token;
        },

        embedCode1() {
            return `<div id="cp-form-container"><\/div>`;
        },

        embedCode2() {
            return `<cp-root><\/cp-root>\r<script>\r  window.cp=window.cp||function(){(cp.q=cp.q||[]).push(arguments)};\r  window.cp('init', '${this.token}');\r<\/script>\r<script async src="https://tag.crowdpower.io/js/app.js"><\/script>`;
        },

        embedCode3() {
            return `<script>\r  window.cp('form', {\r    id: '${this.$route.params.id}',\r    target: 'cp-form-container',\r    width: '100%'\r  });\r<\/script>`;
        },

    },

    mounted() {
        this.getForm();
    },

    methods: {

        getForm() {
            let requests = [
                FormApi.getForm(this.form.id),
                ProjectApi.getKeys(this.project.id),
            ];
            axios.all(requests)
                .then(axios.spread((resForm, resKeys) => {
                    this.starting = false;
                    this.$store.commit('form/setForm', resForm.data.data);
                    this.apiKeys = resKeys.data.data;
                }), () => {
                    this.starting = false;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
